import { invertIntDate, yyyymmddStringToDateID } from "../../../../utilities/dateUtils";
import { FundsPrices, FundsPricesEndpoint } from "../domain/FundsPrices.model";

type Dictionary = {
    [key: string]: string;
};

const fundsPricesAttributesDiccionary: Dictionary = {
    id: 'Fecha',
    investmentInstrumentId: 'InstrumentoInversionID',
    closingPrice: 'Precio',
}

export const createAdapterToFieldFundsPricesEndpoint = (key: string): string => {
    return fundsPricesAttributesDiccionary[key];
}

export const createAdapterToFundsPricesEndpoint = (fundsPrices: FundsPrices) => {
    const formattedFundsPrices: Partial<FundsPricesEndpoint> = {
        PrecioFondoID: fundsPrices.fciPriceId,
        Fecha: yyyymmddStringToDateID(fundsPrices.date.toString(), "-"),
        InstrumentoInversionID: fundsPrices.investmentInstrument?.id,
        PrecioCierre: fundsPrices.closingPrice,
    };
    return formattedFundsPrices;
}

export const createAdapterEndpointToFundsPrices = (fundsPricesEndpoint: FundsPricesEndpoint) => {
    const formattedFundsPrices: FundsPrices = {
        fciPriceId: fundsPricesEndpoint.PrecioFondoID,
        date: invertIntDate(fundsPricesEndpoint.Fecha),
        investmentInstrument: {
            id: fundsPricesEndpoint.InstrumentoInversion.InstrumentoInversionID,
            name: fundsPricesEndpoint.InstrumentoInversion.InstrumentoInversion
       },
        closingPrice: fundsPricesEndpoint.PrecioCierre,
        isin: fundsPricesEndpoint.InstrumentoInversion.ISIN
    };
    return formattedFundsPrices;
}